// extracted by mini-css-extract-plugin
module.exports = {"image":"Home_image__2qLHx","textFooter":"Home_textFooter__3NUWv","container":"Home_container__1s89M"};